export default __webpack_public_path__ + "static/media/algae.90c4681e.jpg";